<app-filter-window
  icon="filter"
  titlePart1="E-INVOICES.FILTER.TITLE"
  titlePart2="ADMIN.LOCAL_OFFICE.LABEL"
>
  <div>
    <eps-select
      [options]="localOffices"
      [busy]="loading"
      [disabled]="busy"
      label="SELECT_CUSTOMER.SALES_ORG"
      [(ngModel)]="selectedLocalOfficeId"
      (ngModelChange)="clearSelection.emit()"
      hideOptionalMarker
      labelWidth="180px"
      ></eps-select>
  </div>
  <div buttons class="buttons">
    <eps-button
      (buttonClick)="edit()"
      [disabled]="busy || !selectedLocalOfficeId"
      type="primary"
      minWidth="160px"
      buttonIcon="pencilAlt"
      label="ADMIN.LOCAL_OFFICE.BUTTONS.EDIT"
      submit
    ></eps-button>
  </div>
</app-filter-window>
